import { Button } from '@/components';
import { useSocket } from '@/providers/socket-io';
import { useNavigate } from 'react-router';
import { NavigationPath } from '@/router/navigation-path.ts';
import Tooltip from '@/components/tooltip';
import { useDevicePermissions } from '@/context/device-permission-context.tsx';

type Props = {
	onSearchUser?: () => void;
	isSearchDisabled?: boolean;
	isSearchLoading?: boolean;
	tooltipText?: string;
	waitingStudent?: number;
};

const InstantMeetingsDefaultState = ({ onSearchUser, isSearchDisabled = false, isSearchLoading = false, tooltipText = 'Şu anda başka bir görüşme için arama gerçekleştiriyorsunuz!', waitingStudent }: Props) => {
	const { isConnected } = useSocket();
	const navigate = useNavigate();
	const { controlPermission } = useDevicePermissions();

	const navigateToProviderTest = () => {
		controlPermission(() => navigate(NavigationPath.meetProviderTest));
	};

	const onClickSearchUser = () => {
		controlPermission(onSearchUser);
	};

	return (
		<div className={'instant-container'}>
			<div className={'instant-info-container'}>
				<h1>Hazırsan Öğrenciler Seni Bekliyor</h1>
				<p>Soru sormak veya rehberlik almak isteyen öğrencilerle anında birebir görüşmeler gerçekleştirin.</p>
			</div>

			<div className={'instant-actions-container'}>
				<i className={'icons-user-circle'} />

				<div className={'waiting-user-container'}>
					<p className={'waiting-student-text'}>
						Şu an görüşme bekleyen <b>{waitingStudent} öğrenci</b>
						<br />
						bulunmaktadır.
					</p>
				</div>

				<Tooltip
					isVisible={isSearchDisabled}
					position={'top'}
					text={tooltipText}>
					<Button
						onClick={onClickSearchUser}
						disabled={isSearchDisabled || !isConnected || isSearchLoading}
						loading={isSearchLoading}>
						Öğrenci Ara
					</Button>
				</Tooltip>
			</div>

			<div className={'instant-footer'}>
				<button
					className={'connection-test-button'}
					onClick={navigateToProviderTest}
					disabled={isSearchDisabled || !isConnected}>
					<i className={'icons-wifi'}></i>
					Bağlantını Test Et
				</button>
			</div>
		</div>
	);
};

export default InstantMeetingsDefaultState;
